module.exports = __webpack_public_path__ + "static/media/history.ac9e01b6.jpg";